import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction } from "@inmagik/react-crud"
import type { Keyword } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { fetchApi, normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useKeywordsList(params: Record<string, string> = {}) {
  return useList<Keyword>(`${API_URL}/admin/keywords`, {
    query: params,
  })
}

export function useKeyword(id: number | undefined) {
  return useDetail<Keyword>(`${API_URL}/admin/keywords`, id?.toString())
}

export function useCreateKeyword() {
  return useCreate<Keyword>(`${API_URL}/admin/keywords`)
}

export function useUpdateKeyword() {
  return useUpdate<Keyword>(`${API_URL}/admin/keywords`)
}

export function useDeleteKeyword() {
  return useDelete(`${API_URL}/admin/keywords`)
}

export function usePartialUpdateKeyword() {
  return usePartialUpdate<Keyword>(`${API_URL}/admin/keywords`)
}

export function useDeleteMultiKeyword() {
  return useAction(`${API_URL}/admin/keywords/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}

export function useKeywordLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/keywords/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Keyword>
  }, [])
}

export function useKeywordsLazy(params: Record<string, string | number | Array<number>> = {}) {
  const auth = useAuth()
  return useCallback((paramsOverride: Record<string, string | number | Array<number>> = {}) => {
    const combinedParams = { ...params, ...paramsOverride }
    const qs = normalizeParams(combinedParams).toString()
    return fetchApi(`${API_URL}/admin/keywords?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Keyword[] }>
  }, [])
}
